import { Image, Page, Text, View } from '@react-pdf/renderer';
import { translations } from './interfaces';
import { FC } from 'react';
import { styles } from './styles';
import introDashboards from './images/intro-dashboards.png';
import { PageNumberFooter, sideLogo } from './helper';

interface IIntroPage {
  translations: translations;
}
export const IntroPage: FC<IIntroPage> = ({ translations }) => (
  <Page orientation="landscape" style={styles.page}>
    <Image source={sideLogo(translations.language)} style={styles.logo} />
    <Text style={styles.header}>{translations.catalogueIntroTitle}</Text>

    <Image source={introDashboards} style={{ width: '100%' }} />
    <View style={styles.pagePadding}>
      <View>
        <View>
          <View style={styles.introPageSubtitleWrapper}>
            <View style={styles.greenBulletPoint} />
            <Text style={styles.introPageSubtitle}>
              {translations.catalogueIntroSubTitle}
            </Text>
          </View>

          <Text style={styles.introPageContent}>
            {translations.catalogueIntroContent}
          </Text>
        </View>

        <View style={{ marginTop: 10 }}>
          <View style={styles.introPageSubtitleWrapper}>
            <View style={styles.greenBulletPoint} />
            <Text style={styles.introPageSubtitle}>
              {translations.catalogueIntroSubTitle2}
            </Text>
          </View>

          <Text style={styles.introPageContent}>
            {translations.catalogueIntroContent2}
          </Text>
        </View>
      </View>
    </View>
    <PageNumberFooter />
  </Page>
);
